import { Layout, Menu } from "antd";
import { Menu as AntMenu, message, Dropdown } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useContext } from "react";

import logo from "../../Assets/Images/Logo.svg";
import dropDown from "../../Assets/Images/dropdown.svg";
import pp from "../../Assets/Images/profilepicture.svg";

import monitorLogo from "../../Assets/Icons/Monitoring.svg";
import monitorLogoSelected from "../../Assets/Icons/Monitoring active.svg";
import securityLogo from "../../Assets/Icons/Security Incidents.svg";
import securityLogoSelected from "../../Assets/Icons/Security Incidents active.svg";
import geoLogo from "../../Assets/Icons/Geofencing.svg";
import geoLogoSelected from "../../Assets/Icons/Geofencing active.svg";
import customerLogo from "../../Assets/Icons/customer manage.svg";
import customerLogoSelected from "../../Assets/Icons/customer manage active.svg";

import { UserOutlined } from "@ant-design/icons";
import { UserContext } from "../../App";
import { Tooltip } from "antd";
import "./style.css";
import settingIcon from "../../Assets/Icons/Settings.svg";

const { Sider } = Layout;

const Sidebar = ({ breakpoint = null, setUser }) => {
  const { userData, setUserData, setUserPages, setUserToken } =
    useContext(UserContext);
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState("null");
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const pathname = location.pathname;
    if (pathname.includes("/dashboard")) {
      setSelectedKey("1");
    } else if (pathname.includes("/vehicle-status")) {
      setSelectedKey("2");
    } else if (pathname.includes("/offline-analysis")) {
      setSelectedKey("3");
    } else if (pathname.includes("high-risk")) {
      setSelectedKey("4");
    } else if (pathname.includes("/theft")) {
      setSelectedKey("5");
    } else if (pathname.includes("/shut-down")) {
      setSelectedKey("6");
    } else if (pathname.includes("/probability")) {
      setSelectedKey("7");
    } else if (pathname.includes("/calls")) {
      setSelectedKey("8");
    } else if (pathname.includes("/geofences")) {
      setSelectedKey("9");
    } else if (pathname.includes("/customer-list")) {
      setSelectedKey("10");
    }
  }, [location.pathname]);

  const userPages = userData?.permissions || [];

  const navigate = useNavigate();

  const goToSettings = () => {
    navigate("/settings");
  };

  const items = [
    userPages?.includes("monitoring") && {
      key: "monitoring",
      icon: (
        <img
          src={
            ["1", "2", "3"].includes(selectedKey)
              ? monitorLogoSelected
              : monitorLogo
          }
          alt="monitorLogo"
        />
      ),
      label: "Monitoring",
      children: [
        { key: "1", label: <Link to="/dashboard">Dashboard</Link> },
        { key: "2", label: <Link to="/vehicle-status">Vehicle Status</Link> },
        {
          key: "3",
          label: <Link to="/offline-analysis">Offline Analysis</Link>,
        },
      ],
    },

    userPages?.includes("security") && {
      key: "security",
      icon: (
        <img
          src={
            ["4", "5", "6", "7", "8"].includes(selectedKey)
              ? securityLogoSelected
              : securityLogo
          }
          alt="securityLogo"
        />
      ),
      label: "Security & Incidents",
      children: [
        { key: "4", label: <Link to="/high-risk">High-Risk Activity</Link> },
        { key: "5", label: <Link to="/theft">Suspected Theft</Link> },
        { key: "6", label: <Link to="/shut-down">Shutdown Logs</Link> },
        { key: "7", label: <Link to="/probability">Probability Meter</Link> },
        { key: "8", label: <Link to="/calls">Call Logs</Link> },
      ],
    },

    userPages?.includes("geoenforcing") && {
      key: "geo",
      icon: (
        <img
          src={["9"].includes(selectedKey) ? geoLogoSelected : geoLogo}
          alt="geoLogo"
        />
      ),
      label: "Geofencing",
      children: [{ key: "9", label: <Link to="/geofences">Geofences</Link> }],
    },

    userPages?.includes("customer") && {
      key: "customer",
      icon: (
        <img
          src={
            ["10"].includes(selectedKey) ? customerLogoSelected : customerLogo
          }
          alt="customerLogo"
        />
      ),
      label: "Customer Manage",
      children: [
        { key: "10", label: <Link to="/customer-list">Customer List</Link> },
      ],
    },
  ].filter(Boolean);
  return (
    <div className="sidebar">
      <Sider
        width={225}
        theme="light"
        collapsible
        collapsed={collapsed}
        onCollapse={(val) => setCollapsed(val)}
        breakpoint={breakpoint}
        collapsedWidth="0"
        style={{ height: "100vh", position: "fixed" }}
      >
        <div className="wrapper">
          <div className="logo-container">
            <img src={logo} alt="logo" />
          </div>

          <div className="ant-menu">
            <div className="menu-heading">All Pages</div>
            <Menu
              mode="inline"
              theme="light"
              selectedKeys={[selectedKey]}
              defaultOpenKeys={["2"]}
              items={items}
            />
          </div>
        </div>

        <div className="logout-div">
          <div className="logout-user">
            <div className="compact-avatar">
              <img className="profile-pic"
                src={
                  userData?.profile_picture
                    ? `${process.env.REACT_APP_MEDIA_URL}${userData.profile_picture}`
                    : customerLogo
                }
                alt="user-icon"
              />
            </div>
            <div className="logout-user-details">
              <div className="role">{userData?.name}</div>

              <span title="Example@company.com" className="email">
                {userData?.email}
              </span>
            </div>
            <div className="logout-icon" style={{ cursor: "pointer" }}>
              <img
                src={settingIcon}
                alt="setting Icon"
                onClick={goToSettings}
              />
            </div>
          </div>
        </div>
      </Sider>
    </div>
  );
};

export default Sidebar;
